export const ORDER_STATES = [
  { order_state_id: 'ec82078f-4029-4ea4-af29-8425835e8a63', name: 'Created' },
  { order_state_id: '648725ec-0da8-4e25-b915-44b410fc0297', name: 'Pending' },
  { order_state_id: '8ef3ded3-15d5-4ed6-b70a-0cc1172594c0', name: 'Payment Problem' },
  { order_state_id: '1bda1b0e-79be-4e3d-8ec6-cdf44de2615d', name: 'Paid' },
  { order_state_id: 'd5165743-5247-4681-8454-b147e428e86e', name: 'Cancelled' },
  { order_state_id: 'b5feaf47-3de0-4d72-bc58-1fb8f1b65c3f', name: 'Abandoned' },
  { order_state_id: '9748eb6a-8c8a-419b-9e09-7d9b3528ece4', name: 'Not Interested' },
  { order_state_id: '688e5bc6-3ecf-4fd6-8d60-6ef199d29bc6', name: 'SentToCourier' },
  { order_state_id: '8dad49fa-f18b-4142-8213-b1f27c290c7a', name: 'ApprovedByCourier' },
  { order_state_id: '2ff5568f-0586-4eb7-b442-a867d3f06c3a', name: 'CanceledByCourier' },
];